import { Button } from '@chakra-ui/react'
import styled from '@emotion/styled'

import theme from 'styles/theme'

export const ApplyButton = styled(Button)`
  width: 100px;
  height: 36px;
  padding: 0;
  background-color: ${theme.token.var('colors.green.a200')};
  border-radius: ${theme.token.var('borderRadius.extraSmall')};
  z-index: 3;

  img {
    width: 20px;
  }
`

export const DeleteButton = styled(ApplyButton)`
  width: 36px;
  background-color: ${theme.token.var('colors.green.a175')};
  color: ${theme.token.var('colors.green.a250')};
`
